import { store } from "../../../../redux/store";
import { useAppSelector } from "../../../../redux/hooks";
import React from "react";

function CheckPermission({
  children,
  permissions,
}: {
  children: React.ReactNode;
  permissions: string[] | string;
}) {
  const { operator } = useAppSelector((state) => state.auth.user);

  const { role } = operator;

  if (
    role.permissions &&
    haveCommonItem(
      permissions,
      role.permissions.map((i) => i.name)
    )
  ) {
    return <>{children}</>;
  }
  return null;
}

export function usePermitted(permissionsNeeded: string[] | string) {
  const { operator } = useAppSelector((state) => state.auth.user);
  const { role } = operator;
  const operatorPermissions = role?.permissions.map((i) => i.name);
  return haveCommonItem(permissionsNeeded, operatorPermissions);
}

function haveCommonItem(permissionNeeded: string | string[], arr2) {
  if (Array.isArray(permissionNeeded)) {
    return permissionNeeded.some((item) => arr2.includes(item));
  } else {
    return arr2.includes(permissionNeeded);
  }
}

export default CheckPermission;
